import { Box, Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ChangePasswordBox = function ChangePasswordBox(_ref) {
  var questionRef = _ref.questionRef,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(Box, {
    ref: questionRef,
    sx: {
      my: 4
    },
    "data-element": "Box",
    "data-component": "ChangePasswordBox",
    "data-source-file": "change-password-box.tsx",
    children: [/*#__PURE__*/_jsx(Typography, {
      sx: {
        mb: 3
      },
      variant: "h2",
      "data-element": "Typography",
      "data-component": "ChangePasswordBox",
      "data-source-file": "change-password-box.tsx",
      children: /*#__PURE__*/_jsx(Translation, {
        "data-element": "Translation",
        "data-component": "ChangePasswordBox",
        "data-source-file": "change-password-box.tsx",
        children: function children(t) {
          return t('Change your password');
        }
      })
    }), children]
  });
};